import React from "react";
import DefaultTemplate from "./templates/Default.js";
import ModalConductor from './components/ModalConductor';

//TODO: template must be dynamic when redux is setup.
class App extends React.Component {
	render () {
		return(
			<div>
			  {this.props.template
			  ? (<this.props.template actionsModal={this.props.actionsModal} children={this.props.children} />)
			  : (<DefaultTemplate actionsModal={this.props.actionsModal} children={this.props.children} />)}
			  <ModalConductor
			    {...this.props}
			  />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js